import TableRow from "../../table/TableRow";

export default class LockTableRow extends TableRow {
    createCellRenderer(cell) {
        if (cell.getColIdx() == 0)
            return this.createRowHeaderRenderer();
        else
            return this.createLockCellRenderer();
    }

    isRowHeaderCreated() {
        return this.cells.length > 0;
    }

    addCellObjWithoutAppend(cellObj) {
        cellObj.setRow(this);
        cellObj.setColIdx(this.cells.length);
        this.cells.push(cellObj);
    }

    getHeaderCell() {
        return this.getCell(0);
    }

    getTodayCell() {
        if (this.getTable().containsViewerTodayColumn()) {
            return this.getCell(this.getTable().getViewerTodayColIdx());
        }
        return null;
    }

    isViewerTodayCell(cell) {
        if (this.getTable().containsViewerTodayColumn()) {
            return cell.getColIdx() == this.getTable().getViewerTodayColIdx();
        }
        return false;
    }

    createRowHeaderRenderer() {
        //Note: should be implemented in inheritor
    }

    createLockCellRenderer() {
        //Note: should be implemented in inheritor
    }
}


// WEBPACK FOOTER //
// ./web/js/locktable/rows/LockTableRow.js